/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { api_getPlagiarismScanDetailsResponse } from '../models/api_getPlagiarismScanDetailsResponse';
import type { api_importPlagiarismScanResultsResponse } from '../models/api_importPlagiarismScanResultsResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PlagiarismScans {
    /**
     * Export applications for plagiarism scan
     * @param id Plagiarism scan export ID
     * @returns binary OK
     * @throws ApiError
     */
    public static exportPlagiarismScanBeneficiaries(
        id: number,
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/plagiarism-scan-exports/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
                502: `Bad Gateway`,
            },
        });
    }
    /**
     * Get plagiarism scan details
     * @returns api_getPlagiarismScanDetailsResponse OK
     * @throws ApiError
     */
    public static getPlagiarismScanDetails(): CancelablePromise<api_getPlagiarismScanDetailsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/plagiarism-scans',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Import plagiarism scan results
     * @param file CSV file to be imported
     * @returns api_importPlagiarismScanResultsResponse OK
     * @throws ApiError
     */
    public static importPlagiarismScanResults(
        file: Blob,
    ): CancelablePromise<api_importPlagiarismScanResultsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/plagiarism-scans',
            formData: {
                'file': file,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
}
